module.exports = __webpack_public_path__ + "img/54_lg.e291ae20.jpg";